import * as React from 'react';

export default function TagIndoor({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 25 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4505 2.74991C12.9819 2.28128 12.2221 2.28128 11.7534 2.74991L3.35343 11.1499C2.8848 11.6185 2.8848 12.3783 3.35343 12.847C3.82205 13.3156 4.58185 13.3156 5.05048 12.847L5.40195 12.4955V20.3984C5.40195 21.0612 5.93921 21.5984 6.60195 21.5984H9.00195C9.6647 21.5984 10.202 21.0612 10.202 20.3984V17.9984C10.202 17.3357 10.7392 16.7984 11.402 16.7984H13.802C14.4647 16.7984 15.002 17.3357 15.002 17.9984V20.3984C15.002 21.0612 15.5392 21.5984 16.202 21.5984H18.602C19.2647 21.5984 19.802 21.0612 19.802 20.3984V12.4955L20.1534 12.847C20.6221 13.3156 21.3819 13.3156 21.8505 12.847C22.3191 12.3783 22.3191 11.6185 21.8505 11.1499L13.4505 2.74991Z"
        fill="currentColor"
      />
    </svg>
  );
}
